let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dG7zJ")).then(() => parcelRequire('cmG7m'));